module.exports = __webpack_public_path__ + "img/icon11.627cec69.png";